import {IHttpService, IPromise, ILogService} from 'angular';
import TSBenutzerBemerkung from '../../models/TSBenutzerBemerkung';
import TSTransitionBemerkung from '../../models/TSTransitionBemerkung';

export default class BemerkungRS {
    serviceURL: string;
    http: IHttpService;

    static $inject = ['$http', 'REST_API', '$log'];
    /* @ngInject */
    constructor($http: IHttpService, REST_API: string, private $log: ILogService) {
        this.serviceURL = REST_API + 'bemerkung';
        this.http = $http;
    }

    public deleteBenutzerBemerkung(benutzerBemerkungId: any): IPromise<any> {
        return this.http.delete(this.serviceURL + '/deleteBenutzerBemerkung/' + encodeURIComponent(benutzerBemerkungId), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }


    public deleteTransitionBemerkung(transitionBemerkungId: any): IPromise<any> {
        return this.http.delete(this.serviceURL + '/deleteTransitionBemerkung/' + encodeURIComponent(transitionBemerkungId), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    public saveBenutzerBemerkung(schadenfallId: any, benutzerBemerkung: TSBenutzerBemerkung): IPromise<TSBenutzerBemerkung> {
        let sentBenutzerBemerkung = {};
        sentBenutzerBemerkung = benutzerBemerkung.serialize(sentBenutzerBemerkung);

        this.$log.debug('sending TSBenutzerBemerkung:');
        this.$log.debug(sentBenutzerBemerkung);

        return this.http.put(this.serviceURL + '/saveBenutzerBemerkung/' + encodeURIComponent(schadenfallId), sentBenutzerBemerkung, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((response: any) => {
            this.$log.debug('PARSING BenutzerBemerkung REST array object', response.data);
            return new TSBenutzerBemerkung().deserialize(response.data);
        });
    }

    public saveTransitionBemerkung(schadenfallId: any, benutzerBemerkung: TSTransitionBemerkung): IPromise<TSTransitionBemerkung> {
        let sentTransitionBemerkung = {};
        sentTransitionBemerkung = benutzerBemerkung.serialize(sentTransitionBemerkung);

        this.$log.debug('sending TSTransitionBemerkung:');
        this.$log.debug(sentTransitionBemerkung);

        return this.http.put(this.serviceURL + '/saveTransitionBemerkung/' + encodeURIComponent(schadenfallId), sentTransitionBemerkung, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((response: any) => {
            this.$log.debug('PARSING TransitionBemerkung REST array object', response.data);
            return new TSTransitionBemerkung().deserialize(response.data);
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/core/service/bemerkungRS.rest.ts